import { gql } from 'graphql-request'

export const SingleEducationQuery = gql`
  query SingleEducation(
    $slug: Education_slug_operator,
    $isPreview: Boolean!,
    $status: Education__status_Input = published,
    $locale: LocaleInputType!
  ) {
    Educations(
        draft: $isPreview,
        locale: $locale,
        where: {
          AND: [
            { slug: $slug }
            { _status: { equals: $status } }
          ]
        }
    ) {
      docs {
        id
        slug
        title
        description
        coverImage ${fragmentMediaQuery}
        content {
          ${fragmentBlockMediaArrayQuery}
          ${fragmentBlockSimpleHeadingQuery}
          ${fragmentBlockSimpleRichTextQuery}
          ${fragmentBlockLinksQuery}
          ${fragmentBlockSummaryQuery}
        }
        participants {
          id
          title
          slug
          sortValue
        }
        events {
          id
          dateTimeStart
          dateTimeEnd
          title 
          location ${fragmentEventLocationQuery}
          event ${fragmentEventQuery}
        }
      }
      totalDocs
    }
  }
`
